import {
  BehaviorConfigsList,
  ManageBehaviorConfigs,
  QipMetricBuilder,
} from '@/features/behavior-config';
import { QipMetricGroupList } from '@/features/behavior-config/routes/QipMetricGroupList';
import { QipMetricQuestionsList } from '@/features/behavior-config/routes/QipMetricQuestionList';
import { QuestionBuilder } from '@/features/behavior-config/routes/QuestionBuilder';
import { QuestionGroupBuilder } from '@/features/behavior-config/routes/QuestionGroupBuilder';
import GuidelinesList from '@/features/guidelines/components/GuidelinesList';
import TemplatesList from '@/features/guidelines/components/TemplatesList';
import AddGuideline from '@/features/guidelines/routes/AddGuideline';
import EditGuideline from '@/features/guidelines/routes/EditGuideline';
import GuidelinesTreatmentIndex from '@/features/guidelines/routes/GuidelinesTreatmentIndex';
import ManageGuidelineTemplate from '@/features/guidelines/routes/ManageGuidelineTemplate';
import { Home, MainContainer } from '@/features/home';
import { OrganizationsList } from '@/features/organizations';
import { ManageOrganizationPage } from '@/features/organizations/routes/ManageOrganization';
import { BehaviorConfigReport } from '@/features/reports/features/qip';
import { ManageUserPage, UsersPage } from '@/features/users';
import React from 'react';
import { RouteObject, useRoutes } from 'react-router-dom';
import IndexPage from './Layout/IndexPage';
import ConferenceList from '@/features/conferences/routes/ConferenceList';

const Router = () => {
  const element = useRoutes(routes);

  return element;
};

export const routes: (RouteObject & Record<string, any>)[] = [
  {
    path: '/',
    element: <MainContainer />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: '/users',
        element: <IndexPage />,
        children: [
          {
            index: true,
            element: <UsersPage />,
          },
          {
            path: ':userId',
            element: <ManageUserPage />,
          },
        ],
      },
      {
        path: '/organizations',
        element: <IndexPage />,
        children: [
          {
            index: true,
            element: <OrganizationsList />,
          },
          {
            path: ':organizationId',
            element: <ManageOrganizationPage />,
          },
        ],
      },
      {
        path: '/conferences',
        element: <IndexPage />,
        children: [
          {
            index: true,
            element: <ConferenceList />,
          },
        ],
      },
      {
        path: '/reports',
        element: <IndexPage />,
        children: [
          {
            path: 'qip',
            element: <BehaviorConfigReport />,
          },
        ],
      },
      {
        path: '/behavior-config',
        element: <IndexPage />,
        children: [
          {
            index: true,
            element: <BehaviorConfigsList />,
          },
          {
            path: ':configId',
            element: <ManageBehaviorConfigs />,
          },
          {
            path: 'add',
            element: <ManageBehaviorConfigs />,
          },
          {
            path: 'qip-metric-builder',
            element: <QipMetricBuilder />,
            children: [
              {
                path: '',
                children: [
                  {
                    index: true,
                    element: <QipMetricQuestionsList />,
                  },
                ],
              },
              {
                path: 'questions',
                children: [
                  {
                    index: true,
                    element: <QipMetricQuestionsList />,
                  },
                ],
              },
              {
                path: 'question-groups',
                children: [
                  {
                    index: true,
                    element: <QipMetricGroupList />,
                  },
                ],
              },
            ],
          },
          {
            path: 'qip-metric-builder/questions/add',
            element: <QuestionBuilder />,
          },
          {
            path: 'qip-metric-builder/questions/:questionId',
            element: <QuestionBuilder />,
          },
          {
            path: 'qip-metric-builder/question-groups/add',
            element: <QuestionGroupBuilder />,
          },
          {
            path: 'qip-metric-builder/question-groups/:groupId',
            element: <QuestionGroupBuilder />,
          },
          {
            path: 'guidelines',
            element: <GuidelinesTreatmentIndex />,
            children: [
              {
                path: '',
                children: [
                  {
                    index: true,
                    element: <GuidelinesList />,
                  },
                ],
              },
              {
                path: 'guideline',
                children: [
                  {
                    index: true,
                    element: <GuidelinesList />,
                  },
                ],
              },
            ],
          },
          {
            path: 'templates',
            element: <GuidelinesTreatmentIndex />,
            children: [
              {
                path: '',
                children: [
                  {
                    index: true,
                    element: <TemplatesList />,
                  },
                ],
              },
              {
                path: 'template',
                children: [
                  {
                    index: true,
                    element: <TemplatesList />,
                  },
                ],
              },
            ],
          },
          {
            path: 'templates/template/:templateId',
            element: <ManageGuidelineTemplate />,
          },
          {
            path: 'templates/template/add',
            element: <ManageGuidelineTemplate />,
          },
          {
            path: 'guidelines/guideline/:guidelineId',
            element: <EditGuideline />,
          },
          {
            path: 'guidelines/guideline/add',
            element: <AddGuideline />,
          },
        ],
      },
    ],
  },
];

export default Router;
